import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from '@zauberware/react-i18n/web'
import { ConfigProvider } from 'antd'
import Backend from 'i18next-xhr-backend'
import moment from 'moment'
import loadLocale, { locales } from './locales'

export const defaultContextValue = {
  language: locales.de,
  setLanguages: () => {},
}

const LocaleContext = React.createContext(defaultContextValue)

export const LocaleProvider = ({ children }) => {
  const [language, setLanguage] = useState(defaultContextValue.language)
  const context = {
    language,
    setLanguage,
  }
  useEffect(() => {
    i18n.use(Backend).init({
      fallbackLng: 'de',
      debug: true,
      defaultNS: 'common',
      ns: ['common', 'umsatz', 'bereiche', 'mitarbeiter'],
      backend: {
        loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
      },
      load: 'unspecific',
      // special options for react-i18next
      // learn more: https://react.i18next.com/components/i18next-instance
      react: {
        useSuspense: true,
      },
    })
    // console.log('i18n initialized')
  }, [])

  useEffect(() => {
    // eslint-disable-next-line no-console
    i18n.changeLanguage(language.name, () => console.log('language change to:', language.name))
  }, [language])

  const [antLocale, setAntLocale] = useState(null)
  loadLocale(language?.name).then(localeObject => {
    moment.locale(localeObject?.moment)
    i18n.changeLanguage(language?.name)
    setAntLocale(localeObject?.antd)
  })
  return (
    <LocaleContext.Provider value={context}>
      <ConfigProvider locale={antLocale}>{children}</ConfigProvider>
    </LocaleContext.Provider>
  )
}
LocaleProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LocaleContext
